import env from 'utils/env';

const host = env.appEnv === 'prod' ? 'fabfitfun' : 'fff-dev';
const cdnUrl = `https://scontent01.${host}.com/exclusive-offers/exclusiveoffers.html`;

const formatOffers = (html) => {
  const offers = [];
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const items = doc.body.getElementsByClassName('offers-item');
  for (let i = 0; i < items.length; i += 1) {
    const obj = {};
    obj.offerId = i + 1;
    obj.offerName = items[i].getElementsByTagName('h3')[0].innerText;
    obj.image = items[i].getElementsByTagName('img')[0].src;
    obj.offerCode = items[i]
      .getElementsByClassName('offer-code')[0]
      .getAttribute('data-clipboard-text');
    obj.text = items[i].getElementsByClassName('offer-text')[0].innerText;
    obj.url = items[i].getElementsByTagName('a')[0].href;
    obj.rule = items[i].getElementsByClassName('item-offer-rule')[0].outerHTML;
    offers.push(obj);
  }
  return offers;
};

const getOffers = () =>
  fetch(cdnUrl)
    .then((response) => response.text())
    .then((responseJson) => formatOffers(responseJson));

export default getOffers;
